import React, { useState } from "react";
import PlaywrightTemplate from "./PlaywrightTemplate";
import styles from "../../styles/Playwrightpages.module.css";
import waitStyles from "../../styles/Wait.module.css";

const PwWaits = () => {
  // reuse state/handlers from regular Wait page
  const [delayedContentMsg, setDelayedContentMsg] = useState("");
  const [delayedContentActive, setDelayedContentActive] = useState(false);
  const [delayedElementVisible, setDelayedElementVisible] = useState(false);
  const [delayedElementActive, setDelayedElementActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [boxes, setBoxes] = useState([]);
  const [showInput, setShowInput] = useState(false);

  function getRandomDelay() {
    return Math.floor(Math.random() * 2500) + 1000;
  }

  function handleLoad3s() {
    setDelayedContentActive(true);
    setIsLoading(true);
    setDelayedContentMsg("");

    setTimeout(() => {
      setIsLoading(false);
      setDelayedContentMsg("Loaded after 30 seconds!");
    }, 30000);
  }

  function handleLoadRandom() {
    setDelayedContentActive(true);
    setIsLoading(true);
    setDelayedContentMsg("");

    const delay = getRandomDelay();

    setTimeout(() => {
      setIsLoading(false);
      setDelayedContentMsg(`Loaded after ${(delay / 1000).toFixed(2)} seconds!`);
    }, delay);
  }

  function handleShow5s() {
    setDelayedElementActive(true);
    setDelayedElementVisible(false);
    setTimeout(() => setDelayedElementVisible(true), 5000);
  }

  function handleHideElement() {
    setDelayedElementActive(false);
    setDelayedElementVisible(false);
  }

  function handleAddBox() {
    setTimeout(() => {
      setBoxes(prev => [...prev, `Box ${prev.length + 1}`]);
    }, 5000);
  }

  function handleRevealInput() {
    setTimeout(() => setShowInput(true), 8000);
  }

  const sections = [
    {
      heading: "Wait Handling",
      ui: (
        <div className={styles.waitContainer}>
          <button onClick={handleLoad3s}>Load Content (30s Delay)</button>
          <button onClick={handleLoadRandom}>Load Content (Random Delay)</button>

          {delayedContentActive && (
            <div style={{ marginTop: '8px' }}>
              {isLoading ? 'Loading...' : delayedContentMsg}
            </div>
          )}

          <br /><br />

          <button onClick={handleShow5s}>Show Element (5s)</button>
          <button onClick={handleHideElement}>Hide Element</button>

          {delayedElementActive && delayedElementVisible && (
            <div style={{ marginTop: '8px' }}>
              This element appears after 5 seconds!
            </div>
          )}
        </div>
      ),
      code: `// Wait for selector
await page.waitForSelector('#content');

// Explicit wait
await page.waitForTimeout(5000);

// Expect visible
await expect(page.locator('#element')).toBeVisible();

// Wait for load state
await page.waitForLoadState('networkidle');`
    }
  ];

  return <PlaywrightTemplate title="Wait Handling" sections={sections} />;
};

export default PwWaits;